import { X } from 'lucide-react';
import { useState } from 'react';

import { useEnarmCatalog } from '@/auth/queries';
import { useCountdown } from '@/lib/motion';

const CLAVE = 'cs-aviso-enarm-cerrado';

/** `cat__enarm` id 6 = «Día 1 ENARM» (primer día del examen). */
const DIA_1_ENARM = 6;

/**
 * Cuenta regresiva al ENARM (antes barra verde de `navbar.php`). La fecha sale de
 * `cat__enarm` (Día 1 ENARM) vía la API; nunca se escribe a mano.
 */
export function AvisoEnarm() {
  const { data } = useEnarmCatalog();
  const enarm = data?.find((i) => i.id === DIA_1_ENARM);
  const fecha = enarm?.date ? `${enarm.date}T07:00:00-06:00` : null;
  const t = useCountdown(fecha);
  const [cerrado, setCerrado] = useState(() => {
    try {
      return sessionStorage.getItem(CLAVE) === '1';
    } catch {
      return false;
    }
  });
  if (!enarm || !fecha || cerrado || t.terminado) return null;

  const cifra = (n: number, etiqueta: string) => (
    <span className="whitespace-nowrap">
      <strong className="text-lg text-cian-texto tabular">{n}</strong> {etiqueta}
    </span>
  );
  return (
    <div className="vidrio-tinte relative rounded-none border-x-0 border-t-0 px-10 py-2 text-center text-sm">
      <span className="mr-2 font-extrabold tracking-wide uppercase">
        ENARM {fecha.slice(0, 4)} · faltan
      </span>
      <span className="inline-flex flex-wrap justify-center gap-x-3">
        {cifra(t.dias, 'días')}
        {cifra(t.horas, 'h')}
        {cifra(t.minutos, 'm')}
        {cifra(t.segundos, 's')}
      </span>
      <button
        type="button"
        onClick={() => {
          try {
            sessionStorage.setItem(CLAVE, '1');
          } catch {
            /* sin almacenamiento */
          }
          setCerrado(true);
        }}
        className="absolute top-1/2 right-3 -translate-y-1/2 rounded-full p-1 text-texto-2 hover:text-texto"
        aria-label="Cerrar aviso"
      >
        <X size={16} />
      </button>
    </div>
  );
}
